module.exports = __webpack_public_path__ + "static/img/14.fd67e4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/14.jpg
// module id = /zbt
// module chunks = 1